import { render, staticRenderFns } from "./MamWalletWithdrawForm.vue?vue&type=template&id=4a18c9c0&scoped=true"
import script from "./MamWalletWithdrawForm.vue?vue&type=script&lang=js"
export * from "./MamWalletWithdrawForm.vue?vue&type=script&lang=js"
import style0 from "./MamWalletWithdrawForm.vue?vue&type=style&index=0&id=4a18c9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a18c9c0",
  null
  
)

export default component.exports